<template>
<v-main  v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :onTop="onTop" :page_title="page_title" v-on:editContent="editContent"></header-common>
  <v-container class="text-left">
    <v-row>
      <v-col md="12" sm="12">
        <p>
          Merci de nous faire confiance pour organiser votre expédition! Remplissez le formulaire ci-dessous pour commencer.
        </p>
        <p  v-if="!connected">
            Si vous pensez que vous utiliserez ce formulaire plus qu'une fois, vous pouvez créer un compte pour mieux consulter et traiter les offres reçus. 
        </p>
      </v-col>
      <v-col md="7">
          <v-form ref="form">
              
              <v-row  v-if="!connected">
                  <v-col cols="12" md="12"><h3>Informations Personnelles</h3></v-col>
                  <v-col cols="12" md="6">
                      <v-text-field :rules="[rules.email, rules.required]" label="E-mail" v-model="customer.email" outlined class="rounded-0"></v-text-field>
                  </v-col>
                <v-col cols="12" md="6">
                    <v-text-field :rules="[rules.required]" v-model="customer.fullname" label="Nom & Prénom | Raison Sociale" outlined class="rounded-0"></v-text-field>
                </v-col>
                <v-col>
                        <v-text-field v-model="customer.adresse" label="Adresse" outlined class="rounded-0"></v-text-field>
                    </v-col>
                <v-col>
                        <v-select v-model="customer.region" :items="['Ariana','Béja','Ben Arous','Bizerte','Gabès','Gafsa','Jendouba','Kairouan','Kasserine','Kébili','Kef','Mahdia','la Manouba','Médenine','Monastir','Nabeul','Sfax','Sidi Bouzid','Siliana','Sousse','Tataouine','Tozeur','Tunis','Zaghouan']" label="Région" outlined class="rounded-0"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12"><h3>Détails de l'Expédition</h3></v-col>
                <v-col cols="12" md="12">
                    <v-radio-group
                        v-model="quotation.class"
                        :rules="[rules.required]"
                        row
                    >
                            <v-radio
                                label="Import"
                                value="Import"
                            ></v-radio>
                            <v-radio
                                label="Export"
                                value="Export"
                            ></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="IncoTerm"
                    v-model="quotation.incoterm"
                    :rules="[rules.required]"
                    outlined
                    class="rounded-0"
                    :items="['EXWORKS','FOB','FCA','DAP','DDP']"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Type"
                    outlined
                    class="rounded-0"
                    v-model="quotation.type"
                    :items="['FCL','FTL','LCL','LTL','Aérien']"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Port / Aéroport d'origine"
                    :rules="[rules.required]"
                    v-model="quotation.depart"
                    outlined
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Port / Aéroport de destination"
                    v-model="quotation.arrivee"
                    :rules="[rules.required]"
                    outlined
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Date embarquement"
                    v-model="quotation.date"
                    outlined
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Type Conteneur"
                    v-model="quotation.conteneur"
                    outlined
                    class="rounded-0"
                    :items="['20\'\' HC', '40\'\' HC','20\'\' DC','40\'\' DC',]"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="quotation.inflammable"
                    label="Inflammable?"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="quotation.gerbable"
                    label="Gerbable?"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Poids Brute"
                    v-model="quotation.poids"
                    outlined
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Longueur"
                    v-model="quotation.longueur"
                    outlined
                    :rules="[rules.required]"
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Largeur"
                    v-model="quotation.largeur"
                    :rules="[rules.required]"
                    outlined
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Hauteur"
                    v-model="quotation.hauteur"
                    :rules="[rules.required]"
                    outlined
                    class="rounded-0"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                    <v-checkbox v-model="terms" :rules="[rules.privacy]">
                        <template v-slot:label>
                            <div>
                            J'ai lu et j'accepte la 
                            <v-tooltip  bottom>
                                <template v-slot:activator="{ on }">
                                <v-btn
                                    target="_blank"
                                    :to="{name:'privacy'}"
                                    color="primary"
                                    class="privacy"
                                    @click.stop
                                    v-on="on"
                                    text
                                >
                                    politique de confidentialité
                                </v-btn>
                                </template>
                                Lire maintenant
                            </v-tooltip>
                             et j'accepte que les informations fournies soient utilisées par Prime Shipping Agency.
                            </div>
                        </template>
                    </v-checkbox>
                </v-col>
                <v-col class="ml-auto col-auto">
                    <v-hover v-slot:default="{ hover }">
                        <v-btn @click="sendRequest" outlined :class="{ 'on-hover': hover }" large color="#1976d2" class="rounded-0 rounded-br-xl text-right"  style="border: 2px solid #1976d2; padding: 26px 15px; transition: all .1s ease-in-out; font-weight:700; margin-right:12px;">Envoyer</v-btn>
                    </v-hover>
                </v-col>
            </v-row>
          </v-form>
      </v-col>
      <v-col cols="12" offset-md="2" md="3">
        <div style="width:100%; height:fit-content; text-align:left; padding:0 30px; background: #003d90 url('https://demo.artureanec.com/html/transx/img/contact_background.png') bottom right no-repeat; background-size: 125px; padding-bottom:20px;clip-path: polygon(85% 0,100% 10%,100% 100%,0 100%,0 0);">
            <h2 style="color:white;font-weight:700; padding-top:20px;">{{ $vuetify.lang.t('$vuetify.pages.home.popup_contact_title') }}</h2>
            <v-btn dark outlined class="rounded-br-xl rounded-0" right style="margin-top:40px;" to="/contact">
            Dites-nous!
            </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <footer-prime></footer-prime>
</v-main>
</template>

<script>
import headerCommon from "./commons/header"
import footerPrime from "./commons/footer"
import logo_light from "../../assets/logo_light.png"
import logo_dark from "../../assets/logo_dark.png"
import aboutImg from "../../assets/section_1.jpg"
import aboutCart from "../../assets/about_cart.png"
import VueJwtDecode from "vue-jwt-decode"

export default {
  name: 'request-quotation',
  data: () => ({
      type: "Import",
      inflammable: false,
      tabs: 'tab2',
      terms: false,
      tab: null,
      gerbable: false,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      page_title: 'request-quotation',
      backgroundUrl: logo_light,
      aboutImage: aboutImg,
      aboutCart: aboutCart,
      connected: false,
      connectedCustomer: {},
      quotation: {},
      onTop: true,
      customer:{},
      rules: {
            required: value => !!value || 'Ce champs est obligatoire.',
            privacy: value => !!value || 'Vous devez lire et accepter notre politique de confidentialité.',
            username: value =>{ 
                const pattern = /^[A-Za-z0-9]+$/
                return value.length >= 3 && pattern.test(value) || 'Le nom d\'utilisateur doit être composé au moins de 3 caractères alpha-numériques.'
            },
            email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vous devez entrer un email valide.',
        },
    }),
    mounted(){
        if(VueJwtDecode.decode(this.$store.getters.getCustomer)){
            this.connectedCustomer = VueJwtDecode.decode(this.$store.getters.getCustomer).customerData
            this.connected = true
        }else{
            this.connected = false
        }
    },
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'Demande de devis'})
      },
      sendRequest() {
          if(this.$refs.form.validate()){
              console.log(this.quotation)
                var customer = {}
                if(this.connected){
                    customer = {
                        fullname: this.connectedCustomer.fullname,
                        code: this.connectedCustomer.code_client,
                        id: this.connectedCustomer.id,
                        email: this.connectedCustomer.email,
                    }
                }else{
                    customer = {
                        fullname: this.customer.fullname,
                        email: this.customer.email,
                        adresse: this.customer.adresse,
                        region: this.customer.region,
                        id: 0
                    }
                }
                this.axios
                    .post("../website/request-quotation", {customer: customer, quotation: this.quotation}, {})
                    .then(res => {
                        console.log(res.data)
                    })
          }
          
          
      }
    },
    components: {
      headerCommon, footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.privacy:before{
    opacity:0 !important;
}
.borderable-btn {
  border:2px solid #1976d2a1;
}
.single-service{
  position:relative;
}
.single-service .hoverable {
  position:absolute;
  width:100%;
  opacity: 0;
  transition: opacity .4s linear .2s;
}
.single-service:hover .hoverable{
  opacity: 1;
}
.quotes {
    background: url('https://i.imgur.com/yOZlJRU.png') no-repeat top left;
    background-size: 80px;
}
.quote-content {
    font-size: 16px;
    line-height: 25px;
    padding: 35px;
}
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.step {
    text-align:left;
    color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 0px;
  font-size: 18px;
  font-weight: 700;
}
.step-title {
    font-weight:700;
    font-size:18px;
    margin-bottom:15px;
    display: block;
}
.img-content {
    width:100%;
    height:550px;
    background-size:cover !important;
}
*{
  transition: all .3s ease-in;
}
.image-service{
    overflow: hidden;
}
.image-service:hover .img-content {
    transform: scale(1.2);
}
.service-position {
    font-size:36px;
    color: #41abff;
}
.description-service {
    position: absolute;
    bottom: 22px;
    left: 0;
    right: 0;
    width: 95%;
    padding: 0 30px 13px 30px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 1;
    font-size:20px;
    font-weight:700;
    color: white;
}
.text-service {
    position: absolute;
    top: 230px;
    left: 25px;
    color: #f3f6f5;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: 1;
}

* {
  font-family: 'Inter', sans-serif;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/request-quotation.vue